// extracted by mini-css-extract-plugin
module.exports = {"search":"_base-search-5a66b46584225c265cc9b7b36125b0f3"};